// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3wG-_","m-signature-pad--body":"styles__m-signature-pad--body___21eo6","m-signature-pad--footer":"styles__m-signature-pad--footer___1iN6N","description":"styles__description___i9bt3","button":"styles__button___28IbL","clear":"styles__clear___3itnF","save":"styles__save___c6iB1","m-signature-pad":"styles__m-signature-pad___2M5Ev","github":"styles__github___1MgrB","noteBtnAndFiltersContainer":"styles__noteBtnAndFiltersContainer___1EJnK","createNoteBtn":"styles__createNoteBtn___3Vfmx","emptyList":"styles__emptyList___2EDMQ"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/EmployableHistory/styles.scss
// module id = tVfH
// module chunks = client